import React from 'react';
import { MainContent } from '../Shell/Content';
import Button from '../Button';
import { classNames } from '../helpers/functions';

export default ({
	children,
	sidebarRight,
	sidebarLeft,
	className,
	onBack,
	backText,
	actions = [],
	contentProps,
	containerClassName,
}) => {
	return (
		<>
			<div className="min-h-full flex flex-col">
				<div className="shadow px-8">
					<div className="flex h-16 justify-between">
						<div className="flex">
							<div className="flex flex-shrink-0 items-center">
								<div className="flex flex-1 justify-end">
									<div
										className="text-xs leading-6 text-gray-700 cursor-pointer"
										onClick={() => {
											onBack();
										}}
									>
										<span aria-hidden="true" className="mr-1.5">
											&larr;
										</span>{' '}
										{backText}
									</div>
								</div>
							</div>
						</div>
						{actions?.length ? (
							<div className="flex items-center">
								{actions.map((action) => (
									<Button
										type={action.type}
										onClick={() => action.onClick()}
										disabled={action.disabled}
									>
										{action.label}
									</Button>
								))}
							</div>
						) : null}
					</div>
				</div>
				<div
					className={classNames(
						'flex xl:overflow-y-auto flex-1',
						containerClassName
					)}
				>
					<MainContent
						sidebarRight={sidebarRight}
						sidebarLeft={sidebarLeft}
						className={className}
						{...contentProps}
					>
						{children}
					</MainContent>
				</div>
			</div>
		</>
	);
};
